import React from 'react';

export const WhenSection = ({ t }) => {
  return (
    <section className="section-padding section-white border-t border-gray-300 relative">
      {/* Subtle grid guides */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none">
        <div className="absolute top-1/3 left-0 right-0 h-px bg-gray-900" />
        <div className="absolute top-2/3 left-0 right-0 h-px bg-gray-900" />
      </div>

      <div className="container mx-auto px-8 max-w-7xl relative z-10">
        {/* Title */}
        <div className="text-center mb-20">
          <h2 className="text-6xl md:text-8xl font-normal text-gray-900 mb-8 leading-tight tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {t.when.title1}<br />{t.when.title2}
          </h2>
          
          {/* Escalation label */}
          <div className="mt-12">
            <p className="text-xs text-gray-500 uppercase tracking-[0.3em] font-light">{t.when.escalationLabel}</p>
          </div>
        </div>

        {/* Escalation Model - Horizontal */}
        <div className="max-w-6xl mx-auto mb-20">
          {/* Stage names with arrows */}
          <div className="flex items-center justify-between mb-16 relative">
            {/* Connecting line */}
            <div className="absolute top-1/2 left-0 right-0 h-px bg-gray-300 transform -translate-y-1/2 z-0" />
            
            {t.when.stages.map((item, index) => (
              <div key={index} className="flex items-center relative z-10">
                <div className="bg-white px-3">
                  <span 
                    className="text-base md:text-lg font-medium text-gray-800 tracking-wide"
                    style={{ 
                      opacity: 0.5 + (index * 0.1),
                      fontWeight: 400 + (index * 50)
                    }}
                  >
                    {item.stage}
                  </span>
                </div>
                {index < t.when.stages.length - 1 && (
                  <svg className="w-6 h-6 ml-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5l7 7-7 7" />
                  </svg>
                )}
              </div>
            ))}
          </div>

          {/* Descriptions below - increasing visual weight */}
          <div className="space-y-8 pt-12 border-t border-gray-200">
            {t.when.stages.map((item, index) => (
              <div 
                key={index}
                className="flex items-start gap-8 relative"
                style={{ 
                  opacity: 0.6 + (index * 0.08)
                }}
              >
                {/* Stage indicator */}
                <div className="flex-shrink-0 w-32">
                  <span 
                    className="text-sm text-gray-500 uppercase tracking-wider font-light"
                  >
                    {item.stage}
                  </span>
                </div>
                
                {/* Separator */}
                <div className="flex-shrink-0 w-px h-6 bg-gray-300" />
                
                {/* Description */}
                <p 
                  className="text-gray-700 font-light leading-relaxed flex-1"
                  style={{
                    fontSize: `${0.95 + (index * 0.025)}rem`,
                    fontWeight: 300 + (index * 20)
                  }}
                >
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Strategic note */}
        <div className="text-center pt-12 border-t border-gray-200">
          <p className="text-sm text-gray-500 font-light max-w-3xl mx-auto">
            {t.when.note}
          </p>
        </div>
      </div>
    </section>
  );
};
